import React, { FC, useEffect, useState } from 'react'
import {
  getQrRemainingSeconds,
  QrPaymentChannel,
  QR_PAYMENT_TIMEOUT_MS,
  resolveQrExpiresAtMs,
} from '../../../../utils/qrPaymentExpiry'

interface IProps {
  isModalOpen: boolean
  paymentChannel: QrPaymentChannel
  resetKey?: string
  expiresAtMs?: number
}

const formatTime = (remainingSeconds: number) => {
  const minutes = Math.floor(remainingSeconds / 60)
  const seconds = remainingSeconds % 60

  if (remainingSeconds >= 60 * 60) {
    const hours = Math.floor(minutes / 60)
    return `${hours.toString().padStart(2, '0')}:${(minutes % 60).toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`
  }

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

const QrExpiryNotice: FC<IProps> = ({ isModalOpen, paymentChannel, resetKey, expiresAtMs }: IProps) => {
  const [remainingSeconds, setRemainingSeconds] = useState(QR_PAYMENT_TIMEOUT_MS[paymentChannel] / 1000)

  useEffect(() => {
    if (!isModalOpen) {
      setRemainingSeconds(QR_PAYMENT_TIMEOUT_MS[paymentChannel] / 1000)
      return
    }

    const deadline = resolveQrExpiresAtMs(paymentChannel, Date.now(), expiresAtMs)
    let intervalId: number | undefined
    const updateRemainingSeconds = () => {
      const nextRemainingSeconds = getQrRemainingSeconds(deadline, Date.now())

      setRemainingSeconds(nextRemainingSeconds)

      if (nextRemainingSeconds === 0 && intervalId !== undefined) {
        window.clearInterval(intervalId)
      }
    }

    updateRemainingSeconds()
    if (deadline > Date.now()) {
      intervalId = window.setInterval(updateRemainingSeconds, 1000)
    }
    document.addEventListener('visibilitychange', updateRemainingSeconds)

    return () => {
      window.clearInterval(intervalId)
      document.removeEventListener('visibilitychange', updateRemainingSeconds)
    }
  }, [isModalOpen, paymentChannel, resetKey, expiresAtMs])

  if (!isModalOpen) {
    return null
  }

  return (
    <p
      className={`text-center text-[15px] font-[500] mt-3 ${
        remainingSeconds === 0 ? 'text-[#dc2626]' : 'text-[#d97706]'
      }`}
    >
      {remainingSeconds > 0 ? `QR có hiệu lực trong: ${formatTime(remainingSeconds)}` : 'QR đã hết hiệu lực'}
    </p>
  )
}

export default QrExpiryNotice
